// extracted by mini-css-extract-plugin
module.exports = {"contents":"ua_contents__Q6qwm","inv":"ua_inv__6jhUQ"};